interface ResolvableTab {
  value: string;
  to: string;
}

/**
 * Resolves which tab is active for the current pathname.
 *
 * A tab matches when the pathname equals its resolved route or sits below it
 * on a path-segment boundary (so `/systems` does not swallow
 * `/systems/landscape`, and `/systemsfoo` matches nothing). The longest match
 * wins; without any match the first tab is the default.
 */
export function resolveActiveTab(tabs: ResolvableTab[], pathname: string, slug: string): string {
  let active = tabs[0]?.value ?? '';
  let longestMatch = 0;

  for (const tab of tabs) {
    const resolved = tab.to.replace('$slug', slug);
    const matches = pathname === resolved || pathname.startsWith(`${resolved}/`);
    if (matches && resolved.length > longestMatch) {
      longestMatch = resolved.length;
      active = tab.value;
    }
  }

  return active;
}
